import ApartmentTypeSelector from 'components/ApartmentTypeSelector';
import { PageContainer } from 'components/PageContainer';
import { WorldFC } from 'components/World';

const CanHoMauPage = (props) => {
  return (
    <PageContainer location={props.location}>
      <WorldFC />
      <ApartmentTypeSelector />
    </PageContainer>
  );
};

export default CanHoMauPage;
